import {
  GET_TEACHERS,
  GET_TEACHERS_FAIL,
  GET_TEACHERS_SUCCESS,
  ADD_NEW_TEACHER,
  ADD_TEACHER_SUCCESS,
  ADD_TEACHER_FAIL,
  UPDATE_TEACHER,
  UPDATE_TEACHER_SUCCESS,
  UPDATE_TEACHER_FAIL,
  DELETE_TEACHER,
  DELETE_TEACHER_SUCCESS,
  DELETE_TEACHER_FAIL,
  
} from "./actionTypes";

export const getTeachers = () => ({
  type: GET_TEACHERS,
})

export const getTeachersSuccess = teachers => ({
  type: GET_TEACHERS_SUCCESS,
  payload: teachers,
})

export const getTeachersFail = error => ({
  type: GET_TEACHERS_FAIL,
  payload: error,
})

export const addNewTeacher = data => ({
  type: ADD_NEW_TEACHER,
  payload: data,
})

export const addTeacherSuccess = teacher => ({
  type: ADD_TEACHER_SUCCESS,
  payload: teacher,
})

export const addTeacherFail = error => ({
  type: ADD_TEACHER_FAIL,
  payload: error,
})

export const updateTeacher = teacher => ({
  type: UPDATE_TEACHER,
  payload: teacher,
})

export const updateTeacherSuccess = teacher => ({
  type: UPDATE_TEACHER_SUCCESS,
  payload: teacher,
})

export const updateTeacherFail = error => ({
  type: UPDATE_TEACHER_FAIL,
  payload: error,
})

export const deleteTeacher = data => ({
  type: DELETE_TEACHER,
  payload: data,
})

export const deleteTeacherSuccess = data => ({
  type: DELETE_TEACHER_SUCCESS,
  payload: data,
})

export const deleteTeacherFail = error => ({
  type: DELETE_TEACHER_FAIL,
  payload: error,
})

